import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { StateWithCompany } from '../company-state';
import { getCompanyState } from './feature.selector';

export const getRemoveCompanyState: MemoizedSelector<StateWithCompany, StateUtils.LoaderState<string>> = createSelector(
  getCompanyState,
  (state) => state?.remove || {},
);

export const getRemoveCompanyLoading: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getRemoveCompanyState,
  (state) => state.loading,
);

export const getRemoveCompanyError: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getRemoveCompanyState,
  (state) => state.error,
);

export const getRemoveCompanyValue: MemoizedSelector<StateWithCompany, string> = createSelector(
  getRemoveCompanyState,
  (state) => state.value,
);
